// ============================================================================
// todo-client-mod -- useUpdateTodo Hook
//
// 更新 Todo 的 Mutation Hook（支持跨分组移动）。
// ============================================================================
import { useState } from 'react';
import { getTodoApiClient } from '../todo-api-client.js';
/**
 * 更新 Todo Mutation
 */
export function useUpdateTodo() {
    const [updating, setUpdating] = useState(false);
    const [error, setError] = useState(null);
    const updateTodo = async (id, params) => {
        setUpdating(true);
        setError(null);
        try {
            const result = await getTodoApiClient().updateTodo(id, params);
            return result;
        }
        catch (err) {
            const message = err instanceof Error ? err.message : '更新待办事项失败';
            setError(message);
            return null;
        }
        finally {
            setUpdating(false);
        }
    };
    const reset = () => {
        setUpdating(false);
        setError(null);
    };
    return {
        updating,
        error,
        updateTodo,
        reset,
    };
}
//# sourceMappingURL=use-update-todo.js.map